import { render, staticRenderFns } from "./ImportPortfolioModal.vue?vue&type=template&id=6e3ea6af&"
import script from "./ImportPortfolioModal.vue?vue&type=script&lang=js&"
export * from "./ImportPortfolioModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports